export default __webpack_public_path__ + "static/210512_更新完成_sc-d72d9f061a5ad264393930f43d8fd4af.webp";